export const shortcuts = [
  { keys: ["G"], description: "Toggle focus mode" },
  { keys: ["F"], description: "Toggle full-screen" },
  { keys: ["P"], description: "Play/Pause music" },
  { keys: ["D"], description: "Toggle dark/light mode" },
  { keys: ["K"], description: "Toggle shortcuts menu" },
  { keys: ["R"], description: "Go to website's repository" },
  { keys: ["S"], description: "Scroll to bottom/top" },
  { keys: ["E"], description: "Extend sidebar" },
  {
    keys: ["Num1", "Num2", "Num3", "..."],
    description: "Navigate between pages",
  },
  { keys: ["M"], description: "Toggle sidebar for the smaller screens" },
  { keys: ["Tap"], description: "Focus system" },
  { keys: ["Space"], description: "Scroll down" },
  { keys: ["Ctrl", "F"], description: "Global search" },
  { keys: ["Ctrl", "P"], description: "Print the website" },
];

export const socialMediaLinks = [
  {
    icon: "github",
    href: "https://github.com/Moamal-2000",
    title: "Github",
  },
  {
    icon: "linkedin",
    href: "https://www.linkedin.com/in/moamal-alaa-a4bb15237",
    title: "Linkedin",
  },
  {
    icon: "codepen",
    href: "https://codepen.io/moamal-2000",
    title: "Codepen",
  },
  {
    icon: "facebook",
    href: "https://www.facebook.com/MoamalAlaa109",
    title: "Facebook",
  },
  {
    icon: "email",
    href: "mailto:moamalalaapro1@gmail.com",
    title: "Send me an email",
  },
];
